import api from "./api";

// POST /contact  { name, email, phone, message }
export const sendContactMessage = (payload) =>
  api.post("/contact", payload).then((res) => res.data);
